import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Tabs,
  Tab,
  Dialog,
  IconButton,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import PortraitIcon from "@mui/icons-material/Portrait";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import PreviewLogo from "../../../assests/flyzone_by_flightloop.png";
import ShareModalStyles from "../../../styles/ShareModal.module.css";
import { predefinedBackgrounds } from "../../../mocks/CustomizeBackgrounds";
import DefaultBackground from "../../../assests/public_page_bg.jpg"; 
import DefaultLogo from "../../../assests/flyzone_by_flightloop.png"; 
import { isValidEmail } from "../../../validations/validations";

const ShareModal = ({
  open,
  onClose,
  recipientName,
  setRecipientName,
  shareEmail,
  setShareEmail,
  handleShareSubmit,
  shareLoading,
  backgroundImage ,
  setBackgroundImage,
  logoImage,
  setLogoImage,
  setBackgroundImageFile,
  setLogoImageFile,
  subscriptionType,
   existingBackgroundImage,  
  existingLogoImage,  
  fetchExistingUrl, 
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [tabValue, setTabValue] = useState(0);
 const [selectedPredefinedBg, setSelectedPredefinedBg] = useState(
    predefinedBackgrounds.find(bg => bg.url === existingBackgroundImage)?.id || null
  );
  const [logoText, setLogoText] = useState(
    existingLogoImage ? "" : "Default Logo Text"
  );
  

  const [logoTextColor, setLogoTextColor] = useState("#000000");
  const [logoTextSize, setLogoTextSize] = useState(48);
  const canvasRef = useRef(null);
  const [showCustomizationNotice, setShowCustomizationNotice] = useState(true);

  useEffect(() => {
    if (showCustomize) {
      fetchExistingUrl();
    }
  }, [showCustomize]);




  const getFileFromUrl = async (url, fileName) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const extension = blob.type.split("/")[1] || "jpg";
      return new File([blob], `${fileName}.${extension}`, { type: blob.type });
    } catch (error) {
      return null;
    }
  };

  const handleBackgroundChange = (e) => {
    const file = e.target.files[0] ;
    setBackgroundImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBackgroundImage(reader.result);
        setSelectedPredefinedBg(null);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setLogoImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoImage(reader.result);
        // Clear text logo when uploading an image
        setLogoText("");
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePredefinedBgSelect = async (bg) => {
    setSelectedPredefinedBg(bg.id);
    setBackgroundImage(bg.url);
    const file = await getFileFromUrl(bg.url, `predefined-bg-${bg.id}`);
    setBackgroundImageFile(file);

  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const convertTextToImage = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext("2d");
    const width = 500;
    const height = 200;
    
    // Set canvas dimensions
    canvas.width = width;
    canvas.height = height;
    
    // Clear canvas
    ctx.clearRect(0, 0, width, height);
    
    // Set background to transparent
    ctx.fillStyle = "rgba(0, 0, 0, 0)";
    ctx.fillRect(0, 0, width, height);
    
    // Set text properties
    ctx.fillStyle = logoTextColor;
    ctx.font = `bold ${logoTextSize}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    
    // Draw text
    ctx.fillText(logoText, width / 2, height / 2);
    
    // Convert canvas to image and set as logo
    canvas.toBlob((blob) => {
      const file = new File([blob], "text-logo.png", { type: "image/png" });
      setLogoImageFile(file);

      const reader = new FileReader();
      reader.onload = () => {
        setLogoImage(reader.result);
      };
      reader.readAsDataURL(blob);
    }, "image/png");
  };

  const handleTextLogoSubmit = () => {
    if (!logoText.trim()) return;
    convertTextToImage();
  };

  const isCustomized = backgroundImage || logoImage || logoText;

  return (
    <>
      {/* Main Share Modal */}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="share-modal-title"
        aria-describedby="share-modal-description"
      >
        <Box className={ShareModalStyles.modalContainer}>
          {showCustomize ? (
            // Customization View
            <Box className={ShareModalStyles.customizeContainer}>
              <Box className={ShareModalStyles.customizeHeader}>
                <IconButton
                  onClick={() => setShowCustomize(false)}
                  className={ShareModalStyles.backButton}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" component="h2">
                  Customize Sharing
                </Typography>
              </Box>
              {showCustomizationNotice && (
                <Box className={ShareModalStyles.notificationBox}>
                  <Typography variant="body2">
                    Please note that this customization will affect your account level settings
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setShowCustomizationNotice(false)}
                    className={ShareModalStyles.closeNoticeButton}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
              <Box className={ShareModalStyles.tabsContainer}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="fullWidth"
                >
                  <Tab
                    label="Background"
                    icon={<WallpaperIcon />}
                    iconPosition="start"
                    className={ShareModalStyles.tab}
                  />
                  <Tab
                    label="Logo"
                    icon={<PortraitIcon />}
                    iconPosition="start"
                    className={ShareModalStyles.tab}
                  />
                </Tabs>
              </Box>

              <Box className={ShareModalStyles.tabContent}>
                {tabValue === 0 && (
                  <Box className={ShareModalStyles.backgroundTab}>
                    <Typography
                      variant="body1"
                      className={ShareModalStyles.sectionTitle}
                    >
                      {subscriptionType === 1
                        ? "Select Background"
                        : "Customize Background"}
                    </Typography>

                    <Grid
                      container
                      spacing={2}
                      className={ShareModalStyles.backgroundGrid}
                    >
                      {predefinedBackgrounds.map((bg) => (
                        <Grid item xs={6} key={bg.id}>
                          <Box
                            className={`${ShareModalStyles.backgroundOption} ${
                              selectedPredefinedBg === bg.id
                                ? ShareModalStyles.selectedBackground
                                : ""
                            }`}
                            onClick={() => handlePredefinedBgSelect(bg)}
                          >
                            <Box
                              component="img"
                              src={bg.url}
                              alt={bg.name}
                              className={ShareModalStyles.backgroundImage}
                            />
                            <Box className={ShareModalStyles.backgroundLabel}>
                              <Typography variant="caption">
                                {bg.name}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>

                    {subscriptionType === 2 && (
                      <>
                        <Typography
                          variant="body2"
                          className={ShareModalStyles.dividerText}
                        >
                          OR
                        </Typography>
                        <Button
                          component="label"
                          variant="contained"
                          startIcon={<CloudUploadIcon />}
                          className={ShareModalStyles.uploadButton}
                        >
                          Upload Custom Background
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleBackgroundChange}
                          />
                        </Button>
                      </>
                    )}

                    {(backgroundImage || existingBackgroundImage || DefaultBackground)   && (
                      <Box className={ShareModalStyles.currentImageContainer}>
                        <Typography variant="body2">
                          Current Background:
                        </Typography>
                        <Box
                          component="img"
                          src={backgroundImage || existingBackgroundImage || DefaultBackground}
                          className={ShareModalStyles.currentImage}
                        />
                      </Box>
                    )}
                  </Box>
                )}

                {tabValue === 1 && (
                  <Box className={ShareModalStyles.logoTab}>
                    <Typography
                      variant="body1"
                      className={ShareModalStyles.sectionTitle}
                    >
                      Customize Logo
                    </Typography>
                    
                    <Box className={ShareModalStyles.logoOptions}>
                      <Box className={ShareModalStyles.optionSection}>
                        <Typography variant="h6">Upload Image Logo</Typography>
                        <Button
                          component="label"
                          variant="contained"
                          startIcon={<CloudUploadIcon />}
                          className={ShareModalStyles.uploadButton}
                          fullWidth
                        >
                          Upload Logo
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleLogoChange}
                          />
                        </Button>
                        {(logoImage || existingLogoImage || DefaultLogo)  && (
                          <Box className={ShareModalStyles.currentImageContainer}>
                            <Typography variant="body2">Current Logo:</Typography>
                            <Box
                              component="img"
                              src={logoImage || existingLogoImage || DefaultLogo}
                              className={ShareModalStyles.currentLogo}
                            />
                          </Box>
                        )}
                      </Box>
                      
                      <Box className={ShareModalStyles.optionDivider}>
                        <Typography variant="body2">OR</Typography>
                      </Box>
                      
                      <Box className={ShareModalStyles.optionSection}>
                        <Typography variant="h6">Create Text Logo</Typography>
                        <TextField
                          fullWidth
                          label="Logo Text"
                          value={logoText}
                          onChange={(e) => setLogoText(e.target.value)}
                          className={ShareModalStyles.textField}
                        />
                        
                        <Grid container spacing={2} className={ShareModalStyles.textLogoControls}>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Text Color"
                              type="color"
                              value={logoTextColor}
                              onChange={(e) => setLogoTextColor(e.target.value)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Text Size"
                              type="number"
                              value={logoTextSize}
                              onChange={(e) => setLogoTextSize(parseInt(e.target.value) || 48)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                min: 10,
                                max: 100,
                              }}
                            />
                          </Grid>
                        </Grid>
                        
                        <Button
                          variant="contained"
                          onClick={handleTextLogoSubmit}
                          disabled={!logoText.trim()}
                          className={ShareModalStyles.createTextLogoButton}
                          fullWidth
                        >
                          Create Text Logo
                        </Button>
                        
                        {logoText && (
                          <Box className={ShareModalStyles.textLogoPreview}>
                            <Typography variant="body2">Preview:</Typography>
                            <canvas 
                              ref={canvasRef} 
                              style={{
                                display: 'none' // Hidden canvas for conversion
                              }} 
                            />
                            <Box 
                              className={ShareModalStyles.textLogoDisplay}
                              style={{
                                color: logoTextColor,
                                fontSize: `${logoTextSize}px`,
                                fontWeight: 'bold'
                              }}
                            >
                              {logoText}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>

              <Grid
                container
                spacing={2}
                className={ShareModalStyles.actionButtons}
              >
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setShowCustomize(false)}
                    className={ShareModalStyles.secondaryButton}
                  >
                    Back
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      setShowCustomize(false);
                      setPreviewOpen(true);
                    }}
                    disabled={!isCustomized}
                    className={ShareModalStyles.primaryButton}
                  >
                    Preview
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ) : (
            // Main Share View
            <Box className={ShareModalStyles.shareContainer}>
              <Typography
                id="share-modal-title"
                variant="h5"
                component="h2"
                className={ShareModalStyles.modalTitle}
              >
                Share File
              </Typography>
              <Typography
                variant="body1"
                className={ShareModalStyles.modalSubtitle}
              >
                Enter the email address of the user you want to share with:
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                label="Recipient Name"
                value={recipientName}
                onChange={(e) => setRecipientName(e.target.value)}
                className={ShareModalStyles.textField}
                helperText={!recipientName.trim() ? "Recipient name is required" : ""}
                required
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                variant="outlined"
                label="Email"
                type="email"
                value={shareEmail}
                onChange={(e) => setShareEmail(e.target.value)}
                className={ShareModalStyles.textField}
                helperText={!isValidEmail(shareEmail) ? "Please enter a valid email address" : ""}
                required
                sx={{ mb: 3 }}
              />

              <Grid
                container
                spacing={2}
                className={ShareModalStyles.customizeButtons}
              >
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setShowCustomize(true)}
                    startIcon={<WallpaperIcon />}
                    className={ShareModalStyles.secondaryButton}
                  >
                    Customize
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<PreviewIcon />}
                    onClick={() => setPreviewOpen(true)}
                    //disabled={!isCustomized}
                    className={ShareModalStyles.secondaryButton}
                  >
                    Preview
                  </Button>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                className={ShareModalStyles.actionButtons}
              >
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={onClose}
                    disabled={shareLoading}
                    className={ShareModalStyles.secondaryButton}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleShareSubmit}
                    disabled={shareLoading || !isValidEmail(shareEmail) || !recipientName.trim()}
                    className={ShareModalStyles.primaryButton}
                  >
                    {shareLoading ? <CircularProgress size={24} /> : "Share"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      </Modal>

      {/* Preview Dialog */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        fullScreen
        PaperProps={{
          className: ShareModalStyles.previewDialog,
          style: {
            backgroundImage: `url(${backgroundImage || existingBackgroundImage || DefaultBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          },
        }}
      >
      

        <IconButton
          onClick={() => setPreviewOpen(false)}
          className={ShareModalStyles.closePreviewButton}
        >
          <CloseIcon />
        </IconButton>

        <Box className={ShareModalStyles.previewContent}>
          <Box>
            {/* Logo at the top */}
            <Box className={ShareModalStyles.previewHeader}>
              <img
                src={logoImage || existingLogoImage || PreviewLogo}
                alt="Company Logo"
                className={ShareModalStyles.companyLogo}
              />
            </Box>

            <Typography variant="h4" className={ShareModalStyles.previewTitle}>
              File Sharing Preview
            </Typography>
            <Typography
              variant="body1"
              className={ShareModalStyles.previewDescription}
            >
              This is how your shared content will appear to recipients.
            </Typography>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default ShareModal;